import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { toast } from '@/lib/v2/components';

import { useAutomationService } from '@/src/infrastructure/Protocol/Automation/useAutomationService';

export const useActionsBarJourneys = () => {
  const { t } = useTranslation();
  const automationService = useAutomationService();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const deleteJourney = useCallback(
    async (ids: number[]) => {
      if (!automationService) return;
      setIsLoading(true);
      const response = await automationService.deleteJourneys(ids);
      if (response.success) {
        toast({
          variant: 'success',
          title: t('useActionsJourneys.deleteAction.title.success'),
          body: t('useActionsBarJourneys.deleteAction.body.success'),
        });
      } else {
        toast({
          variant: 'error',
          title: t('useActionsJourneys.deleteAction.title.error'),
          body: t('useActionsJourneys.deleteAction.body.error'),
        });
      }
      setIsLoading(false);
    },
    [automationService, t]
  );

  const duplicateJourney = useCallback(
    async (name: string, messageID: number) => {
      if (!automationService) return;
      setIsLoading(true);
      const response = await automationService.duplicateJourney(name, messageID);
      if (response.success) {
        toast({
          variant: 'success',
          title: t('useActionsJourneys.duplicateMessage.title.success'),
          body: t('useActionsBarJourneys.duplicateMessage.body.success'),
        });
        setIsLoading(false);
        return { isValidInput: response.success, message: response.data };
      } else {
        setIsLoading(false);
        return {
          isValidInput: response.success,
          message: t(`useActionsJourneys.duplicateMessage.body.error.${response.data}`),
        };
      }
    },
    [automationService, t]
  );

  const renameJourney = useCallback(
    async (name: string, id: number) => {
      if (!automationService) return;
      setIsLoading(true);
      const response = await automationService.renameJourney(name, id);
      console.log('renameJourney response: ', response);
      if (response.success) {
        toast({
          variant: 'success',
          title: t('useActionsJourneys.renameMessage.title.success'),
          body: t('useActionsJourneys.renameMessage.body.success'),
        });
        setIsLoading(false);
        return { isValidInput: response.success, message: response.data };
      } else {
        setIsLoading(false);
        return {
          isValidInput: response.success,
          message: t(`useActionsJourneys.duplicateMessage.body.error.${response.data}`),
        };
      }
    },
    [automationService, t]
  );

  return { isLoading, deleteJourney, renameJourney, duplicateJourney };
};
